




























import { Component, Vue } from 'vue-property-decorator';
import History from '@/components/History.vue'; // @ is an alias to /src

@Component({
  components: {
    History,
  },
})
export default class Home extends Vue {

  private settings: any;

  public constructor() {
    super();
    this.settings = this.$store.getters.settings;
  }

  private bluetoothSupport() {
    return !navigator.bluetooth;
  }

  private checkLocations() {
    return this.settings.locations.length === 0;
  }

  private checkExercises() {
    return this.settings.exercises.length === 0;
  }
}
